module.exports = __webpack_public_path__ + "static/contacts-banner-4875284eedf500440994b556e5a03483.jpg";